{
  "familyId": "SWW-TT-INV-TRICK",
  "questions": [
    {
      "id": "SWW-TT-INV-TRICK-001",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist? '... jij ook mee naar het feest?'",
      "options": ["Ga", "Gaat", "Gaan", "Ging"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie Regel", "content": "Inversie geldt ALLEEN bij jij/je. Bij 'Ga jij?' gebruik je de stam. Bij 'Gaat hij?' blijft de -t staan.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_rule",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Bij inversie staat 'jij' achter het werkwoord. Dan valt de -t weg: gebruik alleen de stam. De stam van 'gaan' is 'ga'. Dus: 'Ga jij?' (niet 'Gaat jij?'). Let op: dit geldt alleen voor jij/je. Bij hij blijft de -t staan: 'Gaat hij?'",
        "solutionSteps": ["Herken inversie: 'jij' staat achter het werkwoord", "Bij inversie met jij/je valt de -t weg", "De stam van 'gaan' is 'ga'", "Antwoord: Ga jij? (niet: Gaat jij?)"],
        "distractorExplanations": {
          "0": "Goed! Inversieregel: bij inversie met 'jij' gebruik je de stam zonder -t: Ga jij?",
          "1": "Je dacht waarschijnlijk dat de -t blijft staan. Maar bij inversie met jij valt de -t weg: 'Jij gaat' → 'Ga jij?' Onthoud: draai de zin om — als de -t wegvalt, is het inversie.",
          "2": "Je dacht waarschijnlijk dat het hele werkwoord past. Maar 'gaan' is het hele werkwoord. Bij inversie gebruik je de stam: ga. Onthoud: het hele werkwoord verwarren met de stam is een veelgemaakte fout.",
          "3": "Je dacht waarschijnlijk aan de verleden tijd. Maar 'ging' is verleden tijd. De zin gaat over het heden ('naar het feest'), dus tegenwoordige tijd: ga."
        }
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-002",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist? '... jij morgen ook naar de training?'",
      "options": ["Kom", "Komt", "Komen", "Kwam"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie met jij", "content": "Bij inversie met jij/je valt de -t weg. 'Jij komt' → 'Kom jij?' De stam van 'komen' is 'kom'.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_komen",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bij inversie met 'jij' valt de -t weg. Normaal: 'Jij komt'. Bij inversie: 'Kom jij?' De stam van 'komen' is 'kom'. Controleer: draai de zin om → 'Jij komt morgen ook naar de training' → 'Kom jij morgen ook naar de training?'",
        "solutionSteps": ["Herken inversie: 'jij' staat achter het werkwoord", "Normaal: 'Jij komt' (stam + t)", "Inversie: -t valt weg → 'Kom jij?'", "Controleer: 'Jij komt' → 'Kom jij?' ✓"],
        "distractorExplanations": {
          "0": "Goed! Bij inversie met jij valt de -t weg: Kom jij?",
          "1": "Je dacht waarschijnlijk dat de -t blijft staan. Maar bij inversie met jij valt de -t altijd weg: 'Jij komt' → 'Kom jij?' Onthoud: inversie + jij = stam zonder -t.",
          "2": "Je dacht waarschijnlijk dat het hele werkwoord past. Maar 'komen' is het hele werkwoord, niet de vervoegde vorm. Bij inversie gebruik je de stam: kom. Onthoud: stam ≠ heel werkwoord.",
          "3": "Je dacht waarschijnlijk aan de verleden tijd. Maar 'kwam' is verleden tijd. De zin gaat over morgen (tegenwoordige tijd voor toekomst): kom."
        }
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-003",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct gespeld?",
      "options": ["Word jij ook uitgenodigd?", "Wordt jij ook uitgenodigd?", "Worden jij ook uitgenodigd?", "Werd jij ook uitgenodigd?"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie bij d-stam", "content": "De stam van 'worden' is 'word' (eindigt op -d). Bij inversie met jij valt de -t weg: 'Jij wordt' → 'Word jij?' Let op: de -d van de stam blijft staan!", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_d_stem",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De stam van 'worden' is 'word' (eindigt op -d). Normaal: 'Jij wordt' (stam + t). Bij inversie valt de -t weg: 'Word jij?' De -d van de stam blijft staan! Dit is een lastige: 'word' ziet er misschien vreemd uit, maar het is correct.",
        "solutionSteps": ["Stam bepalen: worden → word (eindigt op -d)", "Normaal: 'Jij wordt' (word + t = wordt)", "Inversie: -t valt weg → 'Word jij?'", "Let op: de -d van de stam blijft!"],
        "distractorExplanations": {
          "0": "Goed! Bij inversie met jij valt de -t weg: 'Jij wordt' → 'Word jij?' De -d van de stam blijft.",
          "1": "Je dacht waarschijnlijk dat 'wordt' blijft staan bij inversie. Maar bij inversie met jij valt de -t altijd weg: 'wordt' → 'word'. Onthoud: de -t van de uitgang verdwijnt, de -d van de stam blijft.",
          "2": "Je dacht waarschijnlijk dat het hele werkwoord past. Maar 'worden' is het hele werkwoord. Bij inversie gebruik je de stam: word. Onthoud: stam ≠ heel werkwoord.",
          "3": "Je dacht waarschijnlijk aan de verleden tijd. Maar 'werd' is verleden tijd. De vraag gaat over het heden: 'Word jij ook uitgenodigd?'"
        }
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-004",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "fill_in",
      "question": "Vul het werkwoord 'vinden' correct in: '... je dat een goed idee?'",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["Vind", "vind"],
        "caseSensitive": false,
        "placeholder": "Typ het werkwoord..."
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie bij d-stam", "content": "De stam van 'vinden' is 'vind' (eindigt op -d). Normaal: 'Je vindt'. Bij inversie valt de -t weg: 'Vind je?' De -d van de stam blijft!", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_fill_in",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De stam van 'vinden' is 'vind' (eindigt op -d). Normaal: 'Je vindt' (vind + t = vindt). Bij inversie staat 'je' achter het werkwoord en valt de -t weg: 'Vind je dat een goed idee?' De -d van de stam blijft staan! Controleer: draai de zin terug → 'Je vindt dat een goed idee' → klopt, want vind + t = vindt. Bij inversie valt alleen de -t van de uitgang weg, nooit de -d van de stam.",
        "solutionSteps": ["Stam bepalen: vinden → vind (eindigt op -d)", "Herken inversie: 'je' staat achter het werkwoord", "Bij inversie valt de -t weg: vindt → vind", "Antwoord: Vind je?", "Controleer: draai om → 'Je vindt' (vind + t) → klopt ✓"]
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-005",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Bij welke zin is de inversieregel NIET van toepassing?",
      "options": ["Morgen gaat hij naar school.", "Lees jij dat boek?", "Kom je ook?", "Vind je dat leuk?"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Wanneer geldt inversie?", "content": "De inversieregel (t valt weg) geldt ALLEEN bij jij/je. Bij hij/zij/het blijft de -t staan. 'Gaat hij' → -t blijft. 'Ga jij' → -t valt weg.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_not_applicable",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De inversieregel (de -t valt weg) geldt alleen bij jij/je. Bij 'Morgen gaat hij naar school' staat 'hij' achter het werkwoord — maar hij is NIET jij, dus de -t blijft staan: 'gaat hij'. Bij de andere drie zinnen staat jij/je achter het werkwoord en valt de -t wél weg: 'Lees jij' (niet 'Leest jij'), 'Kom je' (niet 'Komt je'), 'Vind je' (niet 'Vindt je'). Onthoud de vuistregel: alleen bij jij/je achter het werkwoord verdwijnt de -t. Bij hij, zij, het, men of een naam blijft de -t altijd staan.",
        "solutionSteps": ["Lees elke zin: wie staat er achter het werkwoord?", "'Gaat hij' → hij staat achter het werkwoord → NIET jij/je → inversieregel geldt NIET", "'Lees jij' → jij → inversieregel geldt wél (-t valt weg)", "'Kom je' → je → inversieregel geldt wél (-t valt weg)", "'Vind je' → je → inversieregel geldt wél (-t valt weg)", "Controleer: alleen bij 'gaat hij' blijft de -t staan → dat is het antwoord ✓"],
        "distractorExplanations": {
          "0": "Goed! Bij 'gaat hij' geldt de inversieregel niet — die geldt alleen bij jij/je, niet bij hij.",
          "1": "Je dacht waarschijnlijk dat 'Lees jij' geen inversie is. Maar 'jij' staat achter het werkwoord → inversie. 'Jij leest' → 'Lees jij?' (-t valt weg). Onthoud: jij achter werkwoord = inversie.",
          "2": "Je dacht waarschijnlijk dat 'Kom je' geen inversie is. Maar 'je' staat achter het werkwoord → inversie. 'Je komt' → 'Kom je?' (-t valt weg). Onthoud: je = jij.",
          "3": "Je dacht waarschijnlijk dat 'Vind je' geen inversie is. Maar 'je' staat achter het werkwoord → inversie. 'Je vindt' → 'Vind je?' (-t valt weg, -d blijft). Onthoud: je = jij."
        }
      }
    }
  ]
}